import { jsx as _jsx } from "react/jsx-runtime";
import { Box, Paper } from "@mui/material";
import { createPortal } from "react-dom";
var FADE_MS = 600;
var ToastStack = function (_a) {
    var toasts = _a.toasts, remove = _a.remove;
    return createPortal(_jsx(Box, { sx: {
            position: "fixed",
            bottom: 16,
            right: 16,
            zIndex: 1400,
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-end",
            pointerEvents: "none",
            width: 280,
        }, children: toasts.map(function (toast) { return (_jsx(Box, { onTransitionEnd: function (e) {
                if (!toast.open && e.target === e.currentTarget && e.propertyName === "max-height") {
                    remove(toast.id);
                }
            }, sx: {
                width: 280,
                maxHeight: toast.open ? 120 : 0,
                overflow: "hidden",
                // height collapses only after fade finishes
                transition: toast.open
                    ? "max-height 300ms cubic-bezier(0.22, 1, 0.36, 1)"
                    : "max-height 180ms ease ".concat(FADE_MS, "ms"),
            }, children: _jsx(Box, { sx: {
                    pb: "6px",
                    "@keyframes toastSlideIn": {
                        "0%": { opacity: 0, transform: "translateX(110%) scale(0.9)" },
                        "65%": { transform: "translateX(-3%) scale(1.01)" },
                        "100%": { opacity: 1, transform: "translateX(0) scale(1)" },
                    },
                    "@keyframes toastFadeOut": {
                        "0%": { opacity: 1 },
                        "100%": { opacity: 0 },
                    },
                    animation: toast.open
                        ? "toastSlideIn 300ms cubic-bezier(0.22, 1, 0.36, 1) forwards"
                        : "toastFadeOut ".concat(FADE_MS, "ms ease forwards"),
                }, children: _jsx(Paper, { sx: {
                        pointerEvents: "auto",
                        background: "#1a1a20",
                        color: "#fff",
                        fontSize: 13,
                        px: "16px",
                        py: "10px",
                        borderRadius: "10px",
                        border: "1px solid rgba(255,255,255,0.09)",
                        boxShadow: "0 8px 32px rgba(0,0,0,0.6), 0 1px 0 rgba(255,255,255,0.06) inset",
                        fontFamily: "var(--default-font)",
                        letterSpacing: "0.01em",
                        width: 280,
                        boxSizing: "border-box",
                    }, children: toast.message }) }) }, toast.id)); }) }), document.body);
};
export default ToastStack;
